<template>
  <div>
    <div class="work_bg">
      <div class="work_title">
        <span> 欢迎您{{ userChName }}登录本系统！ </span>
      </div>
      <div class="work_content">
        <storeStatistic ref="storeStatistic"></storeStatistic>
      </div>
      <div class="work_content">
        <storeMonthNumStatistic ref="storeMonthNumStatistic"></storeMonthNumStatistic>
      </div>
    </div>
  </div>
</template>
<script>
import storeStatistic from "./storeStatistic.vue";
import storeMonthNumStatistic from "./storeMonthNumStatistic.vue";
export default {
  data() {
    return {
      userChName: "用户",
      roleName: "角色",
      deptName: "部门",
    };
  },
  components: {
    storeStatistic,
    storeMonthNumStatistic,
  },

  created() {
    this.GetUserInfo();
  },

  mounted() { },

  methods: {
    GetUserInfo() {
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      if (userdata) {
        this.userChName = userdata.userInfo.chName;
        this.roleName = userdata.roleInfo.roleName;
        this.deptName = userdata.userInfo.dept;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.work_bg {
  width: 100%;
  height: calc(100vh - 75px);
  background-color: rgb(242, 242, 247);
  overflow-y: auto;
}

.work_title {
  width: 100%;
  background-color: white;
  padding: 20px;

  span {
    font-size: 32px;
    font-weight: 700;
    font-family: 楷体;
  }
}

.work_content {
  width: calc(100% - 70px);
  min-height: 150px;
  background-color: white;
  margin: 15px;
  border-radius: 15px;
  padding: 20px;
}
</style>